import * as XLSX from "xlsx";
import { CreateQuestionRequest } from "../entry/server/game.ts";

export type ParseQuestionsXlsxError = {
  rowIndex: number;
  message: string;
};

export type ParseQuestionsXlsxResult = {
  rows: CreateQuestionRequest[];
  errors: ParseQuestionsXlsxError[];
};

function cellToString(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value).trim();
}

function parseCorrectOption(value: unknown): number | null {
  if (typeof value === "number" && Number.isInteger(value) && value >= 1 && value <= 4) {
    return value;
  }
  const text = cellToString(value);
  if (!text) return null;
  const n = Number(text);
  if (Number.isInteger(n) && n >= 1 && n <= 4) return n;
  return null;
}

function isRowEmpty(cells: unknown[]): boolean {
  return cells.every((cell) => cellToString(cell) === "");
}

export async function parseQuestionsXlsx(file: File): Promise<ParseQuestionsXlsxResult> {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    return { rows: [], errors: [{ rowIndex: 0, message: "فایل Excel خالی است." }] };
  }

  const sheet = workbook.Sheets[sheetName];
  const raw = XLSX.utils.sheet_to_json<unknown[]>(sheet, { header: 1, defval: "" });
  if (!raw.length) {
    return { rows: [], errors: [{ rowIndex: 0, message: "هیچ داده‌ای در شیت یافت نشد." }] };
  }

  const dataRows = raw.slice(1);
  const rows: CreateQuestionRequest[] = [];
  const errors: ParseQuestionsXlsxError[] = [];

  dataRows.forEach((row, dataIndex) => {
    const rowIndex = dataIndex + 2;
    const arr = Array.isArray(row) ? row : [];
    const cells = arr.slice(1);

    if (isRowEmpty(cells)) return;

    const question = cellToString(cells[0]);
    const option1 = cellToString(cells[1]);
    const option2 = cellToString(cells[2]);
    const option3 = cellToString(cells[3]);
    const option4 = cellToString(cells[4]);
    const correct = parseCorrectOption(cells[5]);

    const missing: string[] = [];
    if (!question) missing.push("متن سوال");
    if (!option1) missing.push("گزینه ۱");
    if (!option2) missing.push("گزینه ۲");
    if (!option3) missing.push("گزینه ۳");
    if (!option4) missing.push("گزینه ۴");

    if (missing.length) {
      errors.push({ rowIndex, message: `فیلدهای خالی: ${missing.join("، ")}` });
      return;
    }

    if (correct === null) {
      errors.push({ rowIndex, message: "پاسخ صحیح باید ۱، ۲، ۳ یا ۴ باشد." });
      return;
    }

    rows.push({
      question,
      option1,
      option2,
      option3,
      option4,
      correct_option: String(correct),
    });
  });

  return { rows, errors };
}
